import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Badge } from "~/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

interface DemoBadgeProps {
  className?: string;
}

export const DemoBadge: FC<DemoBadgeProps> = ({ className }) => {
  const intl = useIntl();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant="secondary"
          className={`bg-purple-100 text-purple-700 hover:bg-purple-100 cursor-default ${className ?? ""}`}
        >
          <FormattedMessage id="demoBadge.label" defaultMessage="Demo" />
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        <p className="max-w-xs">
          {intl.formatMessage({
            id: "demoBadge.tooltip",
            defaultMessage:
              "This is sample data to explore Sky's features. You can delete it anytime.",
          })}
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
